import { createContext, useContext } from 'react';

import { type Match } from '@services/MatchesService';

export type ChatSafetyState = {
  isDialog?: boolean;
  isConfirmBlocking?: boolean;
  isDeleting?: boolean;
};

export type ChatSafetyContextType = {
  updateChatSafetyState: <T extends keyof ChatSafetyState>(
    key: T,
    value: boolean | 'toggle',
  ) => void;
  chatVisibleBySafetySelector: (profile?: Match) => boolean;
  chatSafetyState: ChatSafetyState;
};

export const ChatSafetyContext = createContext<ChatSafetyContextType>({
  updateChatSafetyState: () => {},
  chatVisibleBySafetySelector: () => true,
  chatSafetyState: {},
});

export const useChatSafetyContext = () => useContext(ChatSafetyContext);
